export default {
  title: 'DE PAGINA DIE JE ZOEKT MOET HIER ERGENS ZIJN...',
  description: "Zoek je een van de onderstaande pagina's?",
  not_found: 'We kunnen de ingevoerde URL niet vinden. Controleer of deze correct is ingevoerd.',
  no_restaurants: {
    title: 'Deze shop is nog niet open voor online bestellingen',
    description: 'Kom binnenkort terug.',
  },
  toasts: {
    failed_to_load_stores: 'Winkels konden niet worden geladen, ververs de pagina',
  },
};
